<template>
  <div class="credits-get-page">
    <div v-if="pending"
         style="min-height: 20rem; position: relative">
      <BasePreloader/>
    </div>
    <div v-else-if="error"
         class="container">
      <ErrorView :code="error.code"
                 :title="error.message"
                 class="container-inner"/>
    </div>
    <div v-else-if="pageData"
         class="credits-get-page__content-wrap  container">
      <div class="credits-get-page__content  container-inner">
        <h1 class="credits-get-page__title">
          {{
            $tCreditsGet(`Your application has been accepted and is already being processed by the bank's representatives.`)
          }}</h1>
        <div class="credits-get-page__ico"></div>
        <div class="credits-get-page__text  text">
          <p>{{ $tCreditsGet('Wait,') }}
            <template v-if="pageData.phone"> {{ $tCreditsGet('by your number') }}
              <span class="credits-get-page__text-tel-wrap">
                <a :href="'+380 67 320 28 58' | toLinkPhone"
                   class="credits-get-page__text-tel  text-nowrap">
                  <b>
                    ({{ formatPhone(pageData.phone) }})
                  </b>
                </a>
              </span>
            </template>
            {{
              $tCreditsGet(`you will be contacted by a bank representative and informed about the decision on the possibility of obtaining a loan.`)
            }}
          </p>
        </div>
        <div class="credits-get-page__thanks">
          {{ $tCreditsGet('Thank you for contacting us!') }}
        </div>
        <router-link-modified :to="{name: 'vacancies'}"
                              class="credits-get-page__btn  base-btn  base-btn--blue">
          <span class="base-btn__text">{{ $tCreditsGet('Return to employment') }}</span>
          <BaseSvg name="ico-arrow-light"/>
        </router-link-modified>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import formatPhone from '@/helpers/formatPhone'
  import ErrorView from '@/components/ErrorView'

  export default {
    name: 'CreditsGetPage',
    components: {
      ErrorView
    },
    data() {
      return {
        error: null,
        pending: false,
        pageData: null,
      }
    },
    computed: {
      redirect() {
        const lang = this.$route.params.lang
        let name = 'credits-get'

        if (
            (!lang || lang === 'ua')
        ) {
          name += '-double'
        }
        const route = this.$router.matcher.match({name, params: {lang}})
        return route.fullPath
      }
    },
    methods: {
      formatPhone,
      send() {
        this.pending = true

        http.post('/api/services/microcredit/order').then(({data}) => {
          if (data.data.error === 'USER_NOT_LOGGED') {
            this.$router.push({name: 'auth', query: {'for-credit': 'true', redirect: this.redirect}})
            return
          }

          this.pageData = data.data.data
        }).catch((error) => {
          this.error = {
            code: error.response.status,
            message: error.response.data && error.response.data.message || error.message
          }
        }).catch((error) => {
          this.error = {
            code: error.response.status,
            message: error.response.data && error.response.data.message || error.message
          }
        }).finally(() => {
          this.pending = false
        })
      }
    },
    created() {
      this.send()
    }
  }
</script>

<style lang="less">

</style>
